/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { View } from 'react-native';
import { isWeb } from '@global/screens';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import SociollaText from '@components/sociolla/SociollaText';
import ScrollContainer from '@components/global/ScrollContainer';
import * as Layout from '@components/screen/Layout';
import NotificationItem from '@/screens/task-notification/components/NotificationItem';

import useApi from '@/hooks/useApi';
import { MsB2b } from '@api/ms-b2b';
import { handleTaskNotificationDetail, isVn } from '@global/helpers';

const PAGE_SIZE = 10;

const TaskNotificationScreen = (props) => {
  const userId = useSelector((state) => state.auth.userId);

  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPagination, setIsPagination] = useState(false);
  const [isEmpty, setIsEmpty] = useState(false);
  const [skip, setSkip] = useState(0);

  const getTasks = useApi(MsB2b.getTasks);
  const getNotifications = useApi(MsB2b.getNotifications);

  const isTask = props?.route?.params?.task ? true : false;

  const mergeSortByCreatedAtDesc = (prev, next) => {
    const map = new Map();

    // de-dupe by id (prefer _id)
    [...(prev || []), ...(next || [])].forEach((it) => {
      const id = it?._id ? String(it._id) : it?.id ? String(it.id) : null;
      if (!id) {
        return;
      }
      map.set(id, { ...it, id });
    });

    return Array.from(map.values()).sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at),
    );
  };

  const normalize = (arr) =>
    (arr || []).map((item) => ({
      ...item,
      id: item?._id ? String(item._id) : item?.id ? String(item.id) : undefined,
    }));

  const doSearchTasks = async (currentSkip = 0, isLoadMore = false) => {
    setIsLoading(true);
    setIsPagination(isLoadMore);
    try {
      const source = isVn() ? 'b2b_vn' : 'b2b';
      const response = await getTasks.request({
        params: {
          filter: {
            users: { $elemMatch: { id: userId } },
            is_completed: { $ne: true },
            is_active_for: { $in: [source] },
          },
          skip: currentSkip,
          limit: PAGE_SIZE,
          sort: '-created_at',
        },
      });
      const new_response = normalize(response?.data?.data);

      if (new_response?.length) {
        if (isLoadMore) {
          setItems((prev) => mergeSortByCreatedAtDesc(prev, new_response));
        } else {
          setItems(mergeSortByCreatedAtDesc([], new_response));
        }

        if (new_response.length < PAGE_SIZE) {
          setIsEmpty(true);
        } else {
          setIsEmpty(false);
        }
      } else {
        if (isLoadMore) {
          setIsEmpty(true);
        } else {
          setItems([]);
          setIsEmpty(true);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
      setIsPagination(false);
    }
  };

  const doSearchNotifications = async (currentSkip = 0, isLoadMore = false) => {
    setIsLoading(true);
    setIsPagination(isLoadMore);
    try {
      const response = await getNotifications.request({
        params: {
          skip: currentSkip,
          limit: PAGE_SIZE,
        },
      });
      const new_response = normalize(response?.data?.data);

      if (new_response?.length) {
        if (isLoadMore) {
          setItems((prev) => mergeSortByCreatedAtDesc(prev, new_response));
        } else {
          setItems(mergeSortByCreatedAtDesc([], new_response));
        }

        if (new_response.length < PAGE_SIZE) {
          setIsEmpty(true);
        } else {
          setIsEmpty(false);
        }
      } else {
        if (isLoadMore) {
          setIsEmpty(true);
        } else {
          setItems([]);
          setIsEmpty(true);
        }
      }
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
      setIsPagination(false);
    }
  };

  const gotToDetail = (data) => {
    handleTaskNotificationDetail({
      data: data,
      navigation: props.navigation,
      isTask,
    });
    // if (data.target.entity === 'orders' && data.target.id) {
    //   const params = {
    //     id: data.target.id,
    //     isTask,
    //   };
    //   if (data?.object?.orderId) {
    //     params.titleScreen = data.object.orderId;
    //   }
    //   props.navigation.navigate('SalesOrderNavigator', {
    //     screen: 'SalesOrderDetailScreen',
    //     params: params,
    //   });
    // } else if (data.target.entity?.indexOf('target-settings') > -1 && data.target.id) {
    //   let temp_target_setting = data.target.entity;
    //   temp_target_setting = temp_target_setting.replace('target-settings', '');
    //   let type = '';
    //   let target_type = '';
    //   let title = '';
    //   let level = 'Level';

    //   if (temp_target_setting?.indexOf('-mt') > -1) {
    //     level = 'MT';
    //   } else if (temp_target_setting?.indexOf('-gt') > -1) {
    //     level = 'GT';
    //   }

    //   if (temp_target_setting?.indexOf('sales-value') > -1) {
    //     type = 'sales-value';
    //     title = 'Sales Value';
    //   } else if (temp_target_setting?.indexOf('product-focus') > -1) {
    //     type = 'product-focus';
    //     title = 'Product Focus';
    //   } else {
    //     type = 'doors';
    //     title = 'DOORS';
    //   }

    //   if (temp_target_setting?.indexOf('national') > -1) {
    //     target_type = 'national';
    //     title += ` - National ${level}`;
    //   } else if (temp_target_setting?.indexOf('channel') > -1) {
    //     target_type = 'channel';
    //     title += ` - Channel ${level}`;
    //   } else if (temp_target_setting?.indexOf('branch') > -1) {
    //     target_type = 'branch';
    //     title += ` - Branch ${level}`;
    //   } else if (temp_target_setting?.indexOf('salesman') > -1) {
    //     target_type = 'salesman';
    //     title += ` - Salesman ${level}`;
    //   }

    //   const params = {
    //     type: type,
    //     targetType: target_type,
    //     targetId: data.target.id,
    //     targetName: title,
    //     targetYear: data?.object?.year,
    //     title: title,
    //   };

    //   props.navigation.navigate('TargetSettingNavigator', {
    //     screen: 'TargetSettingApprovalScreen',
    //     params: params,
    //   });
    // } else {
    //   props.navigation.navigate('TaskNotificationDetailScreen', {
    //     titleScreen: data.title ? data.title : '',
    //     name: data.title ? data.title : '',
    //     id: data._id,
    //     isTask,
    //   });
    // }
  };

  const resetVar = () => {
    setSkip(0);
    setIsEmpty(false);
    setItems([]);
  };

  useEffect(() => {
    const unsubscribe = props.navigation.addListener('focus', () => {
      resetVar();

      if (props?.route?.params?.task) {
        doSearchTasks(0, false);
      } else {
        doSearchNotifications(0, false);
      }
    });
    return unsubscribe;
  }, [props?.route?.params?.task]);

  useEffect(() => {
    if (skip > 0) {
      if (props?.route?.params?.task) {
        doSearchTasks(skip, true);
      } else {
        doSearchNotifications(skip, true);
      }
    }
  }, [skip, props?.route?.params?.task]);

  return (
    <Layout.Container>
      {isWeb ? (
        <>
          <Layout.Title title={isTask ? 'Task' : 'Notification'} />
        </>
      ) : (
        false
      )}
      <Layout.Wrapper rounded>
        <ScrollContainer
          style={{
            width: '100%',
            paddingHorizontal: isWeb ? 20 : 0,
            paddingVertical: isWeb ? 20 : 0,
          }}>
          {isLoading && !isPagination ? (
            <Layout.Loader />
          ) : items && items.length ? (
            <>
              {items.map((item, idx) => (
                <NotificationItem
                  key={item?.id || idx}
                  item={item}
                  isList
                  onPress={() => gotToDetail(item)}
                />
              ))}

              {isLoading && isPagination ? (
                <Layout.Loader />
              ) : !isEmpty ? (
                <>
                  <View
                    style={{
                      width: '100%',
                      paddingHorizontal: 20,
                      paddingTop: 20,
                      paddingBottom: !isWeb ? 20 : 0,
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                    <Button
                      type="primary"
                      rounded={true}
                      buttonStyle={{ width: 110 }}
                      title={
                        <SociollaText
                          type="bold"
                          style={{
                            fontSize: 14,
                            letterSpacing: 0.5,
                            color: Colors.white,
                          }}>
                          Load More
                        </SociollaText>
                      }
                      onPress={() => setSkip((s) => s + PAGE_SIZE)}
                    />
                  </View>

                  {!isWeb ? (
                    <View style={{ width: '100%', height: 100 }} />
                  ) : (
                    false
                  )}
                </>
              ) : (
                false
              )}
            </>
          ) : (
            <View style={{ flexDirection: 'row', padding: !isWeb ? 20 : 0 }}>
              <SociollaText>Data not found.</SociollaText>
            </View>
          )}
        </ScrollContainer>
      </Layout.Wrapper>
    </Layout.Container>
  );
};

export default TaskNotificationScreen;
